import React, { FunctionComponent } from 'react';
import { Icon, Toast } from 'rs-emd-ui-atoms';
import styles from './login-toast-component.module.scss';
import { getLabel } from '../../../../helpers/html.utils';
import { ILabel } from '../../../../models/common/label.model';

type LoginToastProps = {
  labels?: ILabel[] | null;
  showToast: boolean;
  customerName?: string;
};

//Visible only for mobile
export const LoginToast: FunctionComponent<LoginToastProps> = (props: LoginToastProps) => {
  return (
    <div className={styles['login-toast']}>
      <Toast
        showToast={props.showToast}
        backgroundColour='stock'
        icon='account'
        text={props.customerName ? `${getLabel(props.labels, 'signed_in_as')} ${props.customerName}` : ''}
      />
    </div>
  );
};
